(function() {
    if (document.getElementsByClassName('c24IeDetected').length > 0) {
        const scrambleChildren = (function (parentEl, fnCallback) {
            for (let iIndex = parentEl.children.length; iIndex >= 0; iIndex--) {
                parentEl.appendChild(parentEl.children[Math.random() * iIndex | 0]);
            }

            fnCallback();
        });

        scrambleChildren(document.querySelector('.c24-browser-info-icons'), function() {
            document.body.className += ' c24-show-browser-info';
        });
    }
})();
